import { withNamespaces } from "react-i18next";
import { Col, Label, Row } from "reactstrap";
import Select from "react-select";
import { useEffect, useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import axios from "axios";
import { API_URL_GET_LANGUAGES } from "src/common/constants";

const SupportedLanguages = [
    "Afrikaans",
    "Albanian",
    "Amharic",
    "Arabic",
    "Armenian",
    "Assamese",
    "Azerbaijani",
    "Basque",
    "Belarusian",
    "Bengali",
    "Bosnian",
    "Bulgarian",
    "Burmese",
    "Catalan",
    "Chinese",
    "Croatian",
    "Czech",
    "Danish",
    "Dutch",
    "English",
    "Estonian",
    "Faroese",
    "Finnish",
    "French",
    "Galician",
    "Georgian",
    "German",
    "Greek",
    "Gujarati",
    "Hebrew",
    "Hindi",
    "Hungarian",
    "Icelandic",
    "Indonesian",
    "Italian",
    "Japanese",
    "Javanese",
    "Kannada",
    "Kazakh",
    "Khmer",
    "Korean",
    "Lao",
    "Latvian",
    "Lithuanian",
    "Macedonian",
    "Malay",
    "Malayalam",
    "Marathi",
    "Mongolian",
    "Nepali",
    "Norwegian",
    "Persian",
    "Polish",
    "Portuguese",
    "Punjabi",
    "Romanian",
    "Russian",
    "Serbian",
    "Sinhala",
    "Slovak",
    "Slovenian",
    "Spanish",
    "Sundanese",
    "Swahili",
    "Swedish",
    "Tagalog",
    "Tamil",
    "Telugu",
    "Thai",
    "Turkish",
    "Ukrainian",
    "Urdu",
    "Uzbek",
    "Vietnamese",
    "Welsh"
];

const UserNativeLanguageSelector = ({
    t,
    onSelect
}) => {
    const [selectedLanguage, setSelectedLanguage] = useState(null);
    const [canStartRecording, setCanStartRecording] = useState(null);

    const fetchLanguagesQuery = useQuery({
        queryKey: [
            "app-fetch-languages-list"
        ],
        queryFn: async () => {
            const respones = await axios.get(
                API_URL_GET_LANGUAGES,
                // {
                //     headers: {
                //         Authorization: `Bearer ${token}`
                //     }
                // }
            );

            return respones.data?.data;
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t("An error occurred while fetching languages list."), {
                type: "error"
            });
        }
    });

    useEffect(() => {
        if(selectedLanguage){
            const canStart = (SupportedLanguages.findIndex((lang) => {
                return selectedLanguage.baseLabel.substr(0, lang.length).toLowerCase() === lang.toLowerCase()
            })) > -1;
            
            setCanStartRecording(canStart);

            onSelect && onSelect(selectedLanguage, canStart);
        }
    }, [
        selectedLanguage
    ]);

    const languages = useMemo(() => {
        return (fetchLanguagesQuery.data || []).map((lang) => {
            return {
                value: lang.id,
                label: t(lang.name),
                baseLabel: lang.name
            }
        })
    }, [
        t,
        fetchLanguagesQuery.data
    ]);

    return (
        <Row className="mb-3">
            <Col sm='12'>
                <Label>
                    {t('Select your native language before recording')}
                </Label>

                <Row className="mb-1">
                    <Col sm='12' md='4'>
                        <Select
                            classNamePrefix="select2-selection"
                            isLoading={fetchLanguagesQuery.isFetching}
                            isDisabled={fetchLanguagesQuery.isFetching}
                            options={languages}
                            placeholder={t("Select")}
                            value={selectedLanguage}
                            onChange={(e) => setSelectedLanguage(e)}
                        />
                    </Col>
                </Row>

                {canStartRecording && (
                    <span className="text-info">
                        {t('Your selected language is supported. You can now record your voice report in your native language.')}
                    </span>
                )}
            </Col>
        </Row>
    )
}

export default withNamespaces()(
    UserNativeLanguageSelector
);